import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export default function LoadingOverlay() {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        zIndex: 9999,
        gap: 2,
      }}
    >
      <CircularProgress size={48} color="primary" />
      <Typography color="text.secondary" fontWeight={500}>
        Redirecting…
      </Typography>
    </Box>
  );
}
